import classnames from 'classnames/bind'

import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface ILineRewardBadgeProps {
  className?: string
}

const LineRewardBadge = ({ className }: ILineRewardBadgeProps) => {
  return <img className={cx('line-reward-badge', className)} src='/images/line-reward-badge.svg' alt='LINE 購物回饋' />
}

export default LineRewardBadge
